<template>
  <div class="footer-tcs">
    <div class="lg-container px-40">
      <div class="xs-flex xs-justify-between xs-flex-wrap">
        <div class="footer-item xs-p-20">
          <h4><span class="uppercase">{{$t('footer.menu')}}</span></h4>
          <nav-category mode="footer"></nav-category>
        </div>
        <div class="footer-item xs-p-20">
          <h4><span class="uppercase">{{$t('footer.aboutus')}}</span></h4>
          <router-link to="/reheatyourpizza" hreflang="en-MY"><span>Reheat your Pizza</span></router-link>
          <router-link to="/allergen-information" hreflang="en-MY"><span>Allergen Information</span></router-link>
          <router-link to="/aboutus" hreflang="en-MY"><span>Our History</span></router-link>
          <div class="clear"></div>
          <router-link to="/careers" hreflang="en-MY"><span>{{$t('footer.careers')}}</span></router-link>
          <div class="clear"></div>
          <router-link to="/crs" hreflang="en-MY"><span>{{$t('footer.csr')}}</span></router-link>
          <!--<div class="clear"></div>-->
          <!--<router-link to="/news"><span>{{$t('footer.news_announcements')}}</span></router-link>-->
          <!-- <div class="clear"></div>
          <a href="http://dinein.pizzahut.com.my" target="_blank"><span>{{$t('footer.dine_in')}}</span></a> -->
          <div class="clear"></div>
          <!-- <a href="http://express.pizzahut.com.my" target="_blank"><span>{{$t('footer.express')}}</span></a>
          <div class="clear"></div> -->
          <router-link to="/sitemap" hreflang="en-MY"><span>{{$t('footer.sitemap')}}</span></router-link>
          <div class="clear"></div>

        </div>
        <div class="footer-item xs-p-20">
          <h4><span class="uppercase">{{$t('footer.customer_service')}}</span></h4>
          <router-link to="/contact" hreflang="en-MY"><span>{{$t('footer.contact_us')}}</span></router-link>
          <div class="clear"></div>
          <a href="/find-a-hut" hreflang="en-MY"><span>Find A Hut</span></a>
          <div class="clear"></div>
          <h4 style="margin-top: 15px;"><span>{{$t('footer.my_account')}}</span></h4>
          <div v-if="!$auth.check()">
            <router-link to="/signup" hreflang="en-MY"><span>{{$t('footer.create_a_account')}}</span></router-link>
            <div class="clear"></div>
            <router-link to="/login" hreflang="en-MY"><span>{{$t('footer.sign_in')}}</span></router-link>
            <div class="clear"></div>
          </div>
          <div v-else>
            <router-link to="/profile"> <span class="p5">{{$t('footer.profile')}}</span></router-link>
          </div>

        </div>
        <div class="footer-item xs-p-20">
          <h4><span class="uppercase">{{$t('footer.policies')}}</span></h4>
          <router-link to="/privacy" hreflang="en-MY"><span>{{$t('footer.privacy')}}</span></router-link>
          <div class="clear"></div>
          <router-link to="/terms" hreflang="en-MY"><span>{{$t('footer.term')}}</span></router-link>
          <div class="clear"></div>
          <router-link to="/halal_policy" hreflang="en-MY"><span>{{$t('footer.halal_policy')}}</span></router-link>
          <div class="clear"></div>
          <router-link to="/e-invoice" hreflang="en-MY"><span>{{$t('footer.e_invoice')}}</span></router-link>
          <div class="clear"></div>
        </div>
        <div class="footer-item footer-item-line xs-p-20 hidden-xs "></div>
        <div class="footer-item xs-p-20">
          <h4><span>{{$t('footer.contact_with_pizza_hut')}}</span></h4>
          <a href="https://www.facebook.com/pizzahutmalaysia/" target="_blank"><span>{{$t('footer.like_fb')}}</span></a>
          <div class="clear"></div>
          <a href="http://twitter.com/pizzahutmsia" target="_blank"><span>{{$t('footer.follow_twitter')}}</span></a>
          <div class="clear"></div>
          <a href="http://www.youtube.com/pizzahutmalaysia" target="_blank"><span>{{$t('footer.watch_youtube')}}</span></a>
          <div class="clear"></div>
          <a href="http://www.instagram.com/pizzahutmalaysia" target="_blank"><span>{{$t('footer.follow_instagram')}}</span></a>
          <div class="clear"></div>
        </div>
      </div>
      <div class="xs-flex-center xs-mb-20 footer-text">
        <router-link to="/contact2/index.html" hreflang="en-MY"><span>{{$t('footer.contact_us')}}</span></router-link> <span class="pr-5">|</span>
        <router-link to="/privacy" hreflang="en-MY"><span>{{$t('footer.privacy')}}</span></router-link> <span class="pr-5">|</span>
        <router-link to="/terms" hreflang="en-MY"><span>{{$t('footer.term')}}</span></router-link>
      </div>
      <div class="footer-text xs-mb-20" v-html="$t('footer.copyright')"/>
      <div class="xs-flex-center xs-mb-20 footer-text text-center" v-html="$t('footer.Compatible')">
      </div>

    </div>
  </div>
</template>

<script>
import NavCategory from '../partials/NavCategory.vue'
export default {
  components: {
    NavCategory
  },
  mounted () {
  },
  data () {
    return {
      menus: [
      ]
    }
  },
  methods: {
  }
}
</script>

<style scoped>
  .footer-text {
    text-align: center;
    white-space: pre-line;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/HomeFooter.vue